
import { computed, defineComponent } from 'vue';
import type { PropType } from 'vue';

import Image from '@hems/component/src/image/Image.vue';
import type { ToastMessageStatusTypeValue } from '@hems/util/src/constant/toastMessage';
import { TOAST_MESSAGE_STATUS_TYPE } from '@hems/util/src/constant/toastMessage';

export default defineComponent({
  name: 'ToastMessage',
  components: { Image },
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String as PropType<ToastMessageStatusTypeValue>,
      default: TOAST_MESSAGE_STATUS_TYPE.SUCCESS,
    },
    isTou: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const statusClass = computed(() => (props.type === TOAST_MESSAGE_STATUS_TYPE.ERROR ? 'error' : ''));

    const iconSrc = computed(() => {
      if (props.type === TOAST_MESSAGE_STATUS_TYPE.SUCCESS) {
        return props.isTou ? 'icons/ic_check' : 'svg/ic_check_line_primary';
      }

      return 'icons/ic_error';
    });

    return {
      iconSrc,
      statusClass,
    };
  },
});
